import { TFunction } from "i18next";

import { TTrainingLicenseDisplayState } from "./trainingLicenseState";

export const getTrainingLicenseLabel = (
  t: TFunction,
  displayState: TTrainingLicenseDisplayState | null,
  licenseFreeCount: number,
) => {
  if (!displayState) {
    return "—";
  }

  return (
    {
      assigned: t("employee.trainingLicenseIssued", { count: licenseFreeCount }),
      available: t("employee.trainingLicenseAvailable", {
        count: licenseFreeCount,
      }),
      training_required: t("employee.trainingLicenseRequired"),
      no_free: t("employee.trainingLicenseNoFree"),
    }[displayState] ?? "—"
  );
};
